import {
  FormControl,
  InputLabel,
  MenuItem,
  Select as MUISelect,
  SelectChangeEvent,
} from "@mui/material";
import React, { useRef, useState } from "react";

const SelectCommons: React.FC<ISelectComponentProps> = (props) => {
  const {
    classNameWrapper,
    className,
    options,
    onChange,
    value,
    hidenOption,
    defaultValue,
    label,
    customSelect,
    name,
    id,
    errorText,
    error,
    placeholder,
    width,
    height,
  } = props;
  const [valueState, setValueState] = useState<string>("");
  const [open, setOpen] = useState(false);
  const selectRef = useRef<HTMLDivElement>(null);

  const handleChangeSelect = (value: string) => {
    setValueState(value);
    if (onChange) {
      onChange(value);
    }
  };

  const handleIconClick = () => {
    setOpen((prevOpen) => !prevOpen);
    if (selectRef) {
      selectRef.current?.click();
    }
  };

  const IconComponent = () => {
    if (
      ((valueState?.trim() && valueState !== "null") ||
        (value?.trim() && value !== "null")) &&
      customSelect &&
      !error
    ) {
      return (
        <img
          src="/images/ico_check.svg"
          alt="Custom Icon"
          style={{
            width: "13px",
            height: "13px",
            marginRight: 10,
          }}
          onClick={handleIconClick}
        />
      );
    }

    return (
      <span onClick={handleIconClick}>
        <i
          className="fa-solid fa-chevron-down fa-2xs"
          style={{ marginRight: 10 }}
        ></i>
      </span>
    );
  };

  return (
    <>
      <FormControl
        className={`components__select  ${classNameWrapper}`}
        sx={{ width }}
      >
        <InputLabel
          sx={{
            transform: "translate(14px, 10px) scale(1)",
            "&.MuiInputLabel-shrink": {
              transform: "translate(14px, -6px) scale(0.75)",
            },
          }}
          id="select-label"
        >
          {label}
        </InputLabel>
        <MUISelect
          labelId="select-label"
          ref={selectRef}
          id={id}
          error={error}
          label={label}
          name={name}
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          value={value ? value : defaultValue ? defaultValue : ""}
          defaultValue={defaultValue}
          className={`select ${className}`}
          onChange={(event: SelectChangeEvent) =>
            handleChangeSelect(event.target.value)
          }
          sx={{
            minWidth: 100,
            "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input": {
              paddingRight: 0,
            },
            height:height
          }}
          IconComponent={IconComponent}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 500,
                overflowY: "auto",
              },
            },
          }}
        >
          {options?.map((item, index) => (
            <MenuItem
              key={index}
              disabled={item.disabled}
              value={item.value ?? ""}
              style={{ fontSize: 14 }}
              hidden={
                hidenOption?.includes(item?.value?.toString() ?? "") ?? false
              }
            >
              {item.label}
            </MenuItem>
          ))}
        </MUISelect>
        {error && errorText && <div className="err-text">{errorText}</div>}
      </FormControl>
    </>
  );
};

export const Select = SelectCommons;
